import script from "./SubmittedTasks.vue?vue&type=script&setup=true&lang=js"
export * from "./SubmittedTasks.vue?vue&type=script&setup=true&lang=js"

import "./SubmittedTasks.vue?vue&type=style&index=0&id=12c59793&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12c59793"]])

export default __exports__